/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Open360BusinessLogicInventoryModelsProductLink } from './open360BusinessLogicInventoryModelsProductLink';
import { Open360BusinessLogicInventoryModelsProductVariant } from './open360BusinessLogicInventoryModelsProductVariant';


export interface Open360BusinessLogicInventoryModelsProduct {
    ID?: string;
    ExternalID?: string;
    Title?: string;
    Description?: string;
    BrandID?: number;
    ItemTypeID?: number;
    /**
     * 1 = Male, 2 = Female
     */
    Gender?: Open360BusinessLogicInventoryModelsProduct.GenderEnum;
    Draft?: boolean;
    NfcStickerCode?: string;
    VerificationRequired?: boolean;
    ClassificationCategoryID?: number;
    Variants?: Array<Open360BusinessLogicInventoryModelsProductVariant>;
    Links?: Array<Open360BusinessLogicInventoryModelsProductLink>;
    RetailerID?: number;
    IsInformation?: boolean;
    CurrencyCode?: string;
    CurrencySign?: string;
}
export namespace Open360BusinessLogicInventoryModelsProduct {
    export type GenderEnum = 1 | 2;
    export const GenderEnum = {
        NUMBER_1: 1 as GenderEnum,
        NUMBER_2: 2 as GenderEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicInventoryModelsProduct.ts